module.exports = __webpack_public_path__ + "static/img/i_mobile_KT.dd2a4dca.png";